import React, { useState, useEffect } from 'react';
import { fuelCostCalculator } from '../../services/logistics/fuel-cost-calculator';
import { formatNumber } from '../../utils/formatting';

const CostCell = ({ costing, shipmentId, companyId }) => {
  const [totalCost, setTotalCost] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const calculateCost = async () => {
      try {
        setLoading(true);
        
        // Get real-time fuel costs
        let fuelCost = 0;
        if (shipmentId && companyId) {
          try {
            const fuelCosts = await fuelCostCalculator.calculateFuelCostsForShipment(
              companyId, 
              shipmentId
            );
            fuelCost = fuelCosts.totalFuelAmount;
          } catch (error) {
            console.warn(`Failed to get real-time fuel cost for shipment ${shipmentId}, using stored value:`, error);
            // Fallback to stored values
            if (costing) {
              const petroAppFuel = parseFloat(costing.petroAppFuelAmount || 0);
              const manualFuel = parseFloat(costing.manualFuelAmount || 0);
              fuelCost = petroAppFuel + manualFuel;
            }
          }
        } else if (costing) {
          // Fallback to stored values if no shipment ID or company ID
          fuelCost = costing.totalFuelAmount || costing.fuel || 0;
        }

        // Other costs from stored costing data
        const maintenanceCost = costing?.maintenanceAmount || costing?.maintenance || 0;
        const stopsCost = (costing?.stops || []).reduce((sum, stop) => sum + (stop.amount || 0), 0);
        const otherCost = (costing?.otherCosts || []).reduce((sum, cost) => sum + (cost.amount || 0), 0);
        const commission = costing?.commissionAmount || costing?.commission || 0;

        const total = fuelCost + maintenanceCost + stopsCost + otherCost + commission;
        setTotalCost(total);
      } catch (error) {
        console.error('Error calculating cost:', error);
        // Fallback to stored values
        if (costing) {
          const fuelCost = costing.totalFuelAmount || costing.fuel || 0;
          const maintenanceCost = costing.maintenanceAmount || costing.maintenance || 0;
          const stopsCost = (costing.stops || []).reduce((sum, stop) => sum + (stop.amount || 0), 0);
          const otherCost = (costing.otherCosts || []).reduce((sum, cost) => sum + (cost.amount || 0), 0);
          const commission = costing.commissionAmount || costing.commission || 0;
          setTotalCost(fuelCost + maintenanceCost + stopsCost + otherCost + commission);
        } else {
          setTotalCost(0);
        }
      } finally {
        setLoading(false);
      }
    };

    calculateCost();
  }, [costing, shipmentId, companyId]);

  if (loading) {
    return (
      <div className="flex items-center">
        <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-gray-400 mr-1"></div>
        <span className="text-xs text-gray-400">Calculating...</span>
      </div>
    );
  }

  return (
    <div className="font-medium">
      {formatNumber(totalCost)}
    </div>
  );
};

export default CostCell;